import Divider from './DividerLine';

export default Divider;
